import { authService } from '@/services/authnService'
// import AuthnService from '@/services/authnService'
// import ProfileService from '@/services/profileService'

// const authService = new AuthService()
// const authnService = new AuthnService()

/*
const initialize = async (store) => {
  try {
    const tenant = await store.dispatch('tenantStore/fetchTenant')
    // await authService.initialize(tenant)
    await authnService.initialize(tenant)
  } catch (error) {
    console.error('[authPlugin]: Initialization failed!', error)
  }
}
*/

export class AuthPlugin {
  static install(Vue, _options) {
    Vue.prototype.$auth = authService
    // Vue.prototype.$profile = profileService
  }
}
